import { API_URL, jwtToken } from "../../../context/appContext";
export default async function cancelOrderById(body) {
    return fetch(`${API_URL}/api/order/cancel_by_id`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        },
        body: JSON.stringify(body)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}